<template>
  <v-card>
    <v-card-title>
      {{ question }}
    </v-card-title>
    <v-card-text>
      <v-radio-group v-model="answer">
        <v-radio v-for="(opt, i) in options" :key="i" :label="opt"></v-radio>
      </v-radio-group>
    </v-card-text>
    <v-card-actions>
      <v-btn text color="primary" @click="$emit('close')">Fechar</v-btn>
      <v-spacer></v-spacer>
      <v-btn :disabled="answer === null" depressed color="primary" @click="submit">Responder</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    answer: null
  }),
  computed: {
    question() {
      return this.$store.state.question.question || ''
    },
    options() {
      return this.$store.state.question.options || []
    }
  },
  methods: {
    submit() {
      this.$emit('submit', this.options[this.answer])
      this.$emit('close')
      this.answer = null
    }
  }
}
</script>

<style>

</style>